import { useEffect, useState } from "react";
import PortalLayout from "@/pages/portal/PortalLayout";
import api from "@/lib/api";
import { Link } from "react-router-dom";

const PortalMessages = () => {
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    api.get("/portal/projects").then((r) => setProjects(r.data.projects)).catch(() => {});
  }, []);

  return (
    <PortalLayout>
      <div className="mb-8">
        <div className="ft-eyebrow mb-2">Messages</div>
        <h1 className="text-3xl font-bold tracking-tight">Project conversations.</h1>
        <p className="text-[var(--ft-muted)] mt-2">Select a project to open its messaging thread with your FLOWTALIS account team.</p>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {projects.map((p) => (
          <Link key={p.id} to={`/portal/projects/${p.id}`} className="ft-card block" data-testid={`msg-thread-${p.id}`}>
            <div className="ft-badge">{p.stage}</div>
            <h2 className="mt-4 text-lg font-semibold">{p.name}</h2>
            <p className="text-sm text-[var(--ft-muted)] mt-1">{p.product_category}</p>
            <div className="mt-4 text-sm font-semibold" style={{ color: "var(--ft-blue)" }}>Open conversation →</div>
          </Link>
        ))}
        {projects.length === 0 && (
          <div className="ft-card md:col-span-2 text-center py-12 text-[var(--ft-muted)]">No project conversations yet.</div>
        )}
      </div>
    </PortalLayout>
  );
};

export default PortalMessages;
